<div [formGroup]="f">
    <div class="expandCollapseContainer mb-1" [ngClass]="'inputEnabled'">
        <button class="expandCollapseHeader filterButton mb-1" (click)="onDisplayDatabaseFilter()" tabindex="0">
            <strong>{{ 'database' | translate | async }}</strong>
            <ng-container *ngIf="displayDatabaseFilter; else expandIcon">
                <svg class="ontario-icon expandCollapseIcon" alt="" aria-hidden="true" focusable="false" sol:category="primary" viewBox="0 0 24 24"
                    preserveAspectRatio="xMidYMid meet">
                    <use href="#ontario-icon-collapse"></use>
                </svg>
            </ng-container>
            <ng-template #expandIcon>
                <svg class="ontario-icon expandCollapseIcon" alt="" aria-hidden="true" focusable="false" sol:category="primary" viewBox="0 0 24 24"
                    preserveAspectRatio="xMidYMid meet">
                    <use href="#ontario-icon-expand"></use>
                </svg>
            </ng-template>
        </button>

        <div *ngIf="displayDatabaseFilter">
            <div class="ontario-form-group">
                <div class="ontario-checkboxes">
                    <div class="checkboxItem" *ngFor="let database of constants.DATABASE_TYPE_OPTIONS">
                        <mat-checkbox class="flex-child" role="checkbox" (change)="onDatabaseTypeChange(database)"
                            attr.aria-label=" {{ database.i18nkey | translate | async }}"
                            [checked]="database.checked">
                            {{ database.i18nkey | translate | async }}
                        </mat-checkbox>
                    </div>
                    <mat-error *ngIf="!dbIsSelected">
                        {{ 'validation.select.option' | translate | async }}
                    </mat-error>
                </div>
            </div>
        </div>
    </div>
</div>